import { render, staticRenderFns } from "./TitleSection.vue?vue&type=template&id=20ffe66f&"
import script from "./TitleSection.vue?vue&type=script&lang=js&"
export * from "./TitleSection.vue?vue&type=script&lang=js&"
import style0 from "./TitleSection.vue?vue&type=style&index=0&id=20ffe66f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports